export var createMuiDividerOverrides = function (_a) {
    var tokens = _a.tokens;
    return {
        styleOverrides: {
            root: {
                borderColor: tokens.color_border_default,
            },
            light: {
                borderColor: tokens.color_border_default,
            },
        },
    };
};
